import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import FileSaver from 'file-saver'
import moment from 'moment-business-days'

import { QueryNames } from 'Hooks/api/queryNames'
import { downloadInvoice } from 'Services/invoices/invoiceService'
import { AppNotification } from 'Utils/types/appNotification'
import { EmployerInfo } from 'Utils/types/employerInfo'
import { EmployerAdminInvoice, JoonAdminInvoice } from 'Utils/types/invoice'
import { buildExcelFileBlob } from 'Utils/helpers/files'

const invoiceFilename = (
  employerId: EmployerInfo['id'],
  employerName: string,
  invoice: JoonAdminInvoice | EmployerAdminInvoice
) => {
  const timestamp = moment(invoice.dateCreated).format('MM-DD-YYYY')
  const sanitizedEmployerName = employerName.replace(/[^a-zA-Z0-9]+/g, '_')
  return `employer_${employerId}_${sanitizedEmployerName}_invoice_${invoice.countryCode}_${timestamp}.xls`
}

export const useDownloadInvoice = () =>
  useMutation(
    [QueryNames.DownloadInvoice],
    async ({
      employerId,
      employerName,
      invoice
    }: {
      employerId: EmployerInfo['id']
      employerName: string
      invoice: JoonAdminInvoice | EmployerAdminInvoice
    }) => {
      const response = await downloadInvoice(employerId, invoice.id)
      if (response.data) {
        FileSaver.saveAs(
          buildExcelFileBlob(response.data),
          invoiceFilename(employerId, employerName, invoice)
        )
        toast.success(AppNotification.InvoiceDownloadSuccess)
      } else {
        toast.error(response.message || AppNotification.InvoiceDownloadFailure)
      }
    },
    {
      onError: () => {
        toast.error(AppNotification.InvoiceDownloadFailure)
        return undefined
      }
    }
  )
